import * as React from 'react';

const LockFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="lock-fill_svg__a"
                d="M12 8V5a4.005 4.005 0 00-4.274-3.991C5.602 1.151 4 3.013 4 5.141V5.5a.5.5 0 11-1 0v-.344C3 2.558 4.917.278 7.502.024 10.473-.267 13 2.086 13 5v3h3v12H0V8h12zm-3.5 6.085a1.5 1.5 0 11-1 0V11.5h1v2.585z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(4 2)">
            <mask id="lock-fill_svg__b" fill="#fff">
                <use xlinkHref="#lock-fill_svg__a" />
            </mask>
            <use
                fill="#45494E"
                transform="matrix(-1 0 0 1 16 0)"
                xlinkHref="#lock-fill_svg__a"
            />
            <g mask="url(#lock-fill_svg__b)">
                <path fill="#000" d="M-4-2h24v24H-4z" />
            </g>
        </g>
    </svg>
);

LockFillSvg.displayName = 'LockFillSvg';
export default LockFillSvg;
